import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import FingerprintJS from '@fingerprintjs/fingerprintjs';

import SubscriptionModal from "./SubscriptionModal";
import Footer from './Footer2';

const ProfileCard = () => {
  const navigate = useNavigate();

  const [lessons, setLessons] = useState([]);
  const [quizUrl, setQuizUrl] = useState("");
  const [deviceFingerprint, setDeviceFingerprint] = useState(null);

  const [loading, setLoading] = useState(false);
  const [errorMessages, setErrorMessages] = useState({});
  const [error, setError] = useState(null);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedLesson, setSelectedLesson] = useState(null);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  /* ===========================================================
     Fetch lessons
  ============================================================ */
  const fetchLessons = async () => {
    setLoading(true);
    try {
      const educationalLevelId = localStorage.getItem('package_id');
      const authToken = localStorage.getItem('authToken');

      if (!authToken || !educationalLevelId) {
        navigate('/LoginIslam');
        return;
      }

      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/lessons/package/${educationalLevelId}`,
        {
          headers: { Authorization: `Bearer ${authToken}` }
        }
      );

      setLessons(response.data);

      if (!response.data.length) {
        alert("لا يوجد محاضرات متاحة.");
      }

    } catch (err) {
      setError(err);
      alert("حدث خطأ أثناء تحميل المحاضرات.");
    } finally {
      setLoading(false);
    }
  };

  /* ===========================================================
     Fetch Quiz URL
  ============================================================ */
  const fetchQuizData = async () => {
    try {
      const educationalLevelId = localStorage.getItem('package_id');
      const token = localStorage.getItem('authToken');

      if (!token || !educationalLevelId) return;

      const quizResponse = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/mcqs/package/${educationalLevelId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      const quizData = await quizResponse.json();

      if (quizData?.mcqs?.length > 0) {
        setQuizUrl(quizData.mcqs[0].url);
      }
    } catch (error) {
      console.error("Error fetching quiz:", error);
    }
  };

  /* ===========================================================
     Fetch Fingerprint
  ============================================================ */
  const fetchDeviceFingerprint = async () => {
    try {
      const fp = await FingerprintJS.load();
      const result = await fp.get();

      setDeviceFingerprint(result.visitorId);
      localStorage.setItem("deviceFingerprint", result.visitorId);

    } catch (err) {
      setErrorMessages(prev => ({ ...prev, global: 'Could not fetch device fingerprint' }));
      navigate('/SignupIslam');
    }
  };

  /* ===========================================================
     Enter lesson
  ============================================================ */
  const handleEnterLesson = (lesson) => {
    localStorage.setItem('lesson_id', lesson.id);
    navigate('/VIDEOislam');
  };

  /* ===========================================================
     Block DevTools
  ============================================================ */
  useEffect(() => {
    const handleKeydown = (e) => {
      if (
        e.key === 'F12' ||
        (e.ctrlKey && e.key === 'u') ||
        (e.ctrlKey && e.shiftKey && e.key === 'I')
      ) {
        e.preventDefault();
        e.stopPropagation();
      }
    };

    const handleContextMenu = (e) => e.preventDefault();

    document.addEventListener('keydown', handleKeydown);
    document.addEventListener('contextmenu', handleContextMenu);

    return () => {
      document.removeEventListener('keydown', handleKeydown);
      document.removeEventListener('contextmenu', handleContextMenu);
    };
  }, []);

  /* ===========================================================
     Resize (Mobile Mode)
  ============================================================ */
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  /* ===========================================================
     Load all on mount
  ============================================================ */
  useEffect(() => {
    fetchLessons();
    fetchQuizData();
    fetchDeviceFingerprint();
  }, []);

  return (
    <div style={{ padding: isMobile ? "15px" : "40px" }}>

      {/* 🔥 Animation definition inside JSX */}
      <style>{`
        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>

      {/* ======================= */}
      {/*       LESSON CARDS      */}
      {/* ======================= */}

      <div style={{ marginTop: 20 }}>
        {loading ? (
          <p>Loading...</p>
        ) : error ? (
          <p style={{ color: "white", fontSize: 24 }}>❌ لا يوجد محاضرات</p>
        ) : (
          lessons.map((lesson) => (
            <div
              key={lesson.id}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "15px",
                padding: "20px",
                margin: "15px 0",
                borderRadius: "18px",
                backdropFilter: "blur(12px)",
                background: "rgba(97, 0, 81, 0.42)",
                border: "1px solid rgba(255,255,255,0.3)",
                animation: "fadeUp 0.6s ease",
                boxShadow: "0 0 12px rgba(255, 255, 255, 0.61)",

                flexDirection: isMobile ? "column" : "row",
                textAlign: isMobile ? "center" : "left",
              }}
            >

              <img
                src="/images/ES/backgroud2s.png"
                alt="Lesson"
                style={{
                  width: isMobile ? "60%" : "130px",
                  height: isMobile ? "60%" : "130px",
                  borderRadius: "15px",
                  objectFit: "cover",
                  boxShadow: "0 0 10px rgba(0,0,0,0.3)"
                }}
              />

              <div style={{ flex: 1 }}>
                <h3 style={{
                  fontSize: isMobile ? "20px" : "26px",
                  color: "white",
                  marginBottom: "10px",
                }}>
                  {lesson.title}
                </h3>

                <p style={{
                  fontSize: isMobile ? "14px" : "17px",
                  color: "#eee",
                  marginBottom: "12px",
                }}>
                  {lesson.description}
                </p>

                <button
                  onClick={() => handleEnterLesson(lesson)}
                  style={{
                    padding: "10px 20px",
                    borderRadius: "12px",
                    border: "none",
                    background: "linear-gradient(45deg, #58de7eff, #007d02ff)",
                    color: "white",
                    fontSize: "16px",
                    cursor: "pointer",
                    width: isMobile ? "100%" : "auto",
                    boxShadow: "0 0 10px rgba(255,255,255,0.4)",
                    transition: "0.3s",
                  }}
                >
                  دخول للمحاضرة
                </button>
              </div>

            </div>
          ))
        )}
      </div>

      {/* QUIZ BUTTON */}
      <div style={{
        padding: 16,
        background: "#3a0239ff",
        borderRadius: 7,
        textAlign: "center",
        marginTop: 20
      }}>
        <a
          style={{ color: "white", fontSize: 24, fontFamily: "Lemonada" }}
          href={quizUrl || "#"}
          onClick={() => {
            if (!quizUrl) alert("لم يتم تنزيل امتحان");
          }}
        >
          الاختبار الشهري
        </a>
      </div>

      <Footer />
    </div>
  );
};

export default ProfileCard;
